import { memo } from 'react';

import {
  BgColorsOutlined,
  ExpandOutlined,
  GiftOutlined,
  GroupOutlined,
  TrophyOutlined,
} from '@ant-design/icons';
import { Col, Row, Tooltip } from 'antd';

import InfoNew from 'screens/Products/components/ProductItem/components/InfoNew';
import { offerTypeColor } from 'screens/Products/utils/consts/OfferType.const';
import SelectPacking from 'components/BusinessLogic/Product/SelectPacking';
import ProductActions from 'screens/Products/components/BuyIntentionActions';

import Quality from 'components/UI/Quality';
import Badge from 'components/UI/Badge';
import ShowDetails from 'components/UI/ShowDetails';
import { getShowPinnedFilter } from 'store/state/offerFilters/offerFiltersSelectors';
import { useSelector } from 'react-redux';

import InfoDelivery from '../../components/InfoDelivery';
import InfoDirectedTag from '../../components/InfoDirectedTag';
import InfoVoucherTag from '../../components/InfoVoucherTag';
import InfoBarCode from '../../components/InfoBarCode';
import InfoObservation from '../../components/InfoObservation';
import InfoVoucher from '../../components/InfoVoucher';
import ProductCardImage from '../../components/ProductCardImage';

import { ModesProps } from '../props';

import {
  ProductCardListComponent,
  ProductCardComponentDetails,
  ProductCardImageContainer,
  ProductNameType,
  InformationProduct,
  Actions,
  InfoNewContainer,
  InfoDirectedTagContainer,
  InfoVoucherTagContainer,
  MainContent,
  BadgeContainer,
  ProductName,
  ProductNameNormal,
  ConceptName,
} from './styles';
import InfoDirected from '../../components/InfoDirected';

function MinifyList({
  product,
  packingSelected,
  handleOnSelectPacking,
  openImage,
  isProducerAuthenticated,
  addInCart,
  buy,
  producerUrl,
  selectedTypeSale,
  onChangePackingTypeSale,
}: ModesProps) {
  const showPinnedFilter = useSelector(getShowPinnedFilter);

  return (
    <ProductCardListComponent>
      {product.isNewOffer && (
        <InfoNewContainer>
          <InfoNew />
        </InfoNewContainer>
      )}

      {product.offerType === 3 && (
        <InfoDirectedTagContainer>
          <InfoDirectedTag specialPrice={product.specialPrice} />
        </InfoDirectedTagContainer>
      )}

      {product.voucherId && (
        <InfoVoucherTagContainer>
          <InfoVoucherTag
            reajustmentAmount={product.reajustmentAmount}
            voucherReajustmentType={product.voucherReajustmentType}
          />
        </InfoVoucherTagContainer>
      )}

      <ProductCardImageContainer>
        <ProductCardImage
          images={product.imagesFormatted}
          imageByProducer={product.images.length > 0 && !product.isLkpOffer}
          maxHeight="50px"
          open={openImage}
        />
      </ProductCardImageContainer>

      <MainContent>
        {/* informações de dimensão e altura */}
        <ProductCardComponentDetails xs={4} sm={8} md={10} lg={13} xl={13}>
          <Row className="row-details-name">
            <Col className="col-details" xs={24}>
              <ProductNameType>
                <div className="name-product-div">
                  <InfoDelivery
                    isLkpOffer={product.isLkpOffer}
                    endDateFormatted={product.endDateFormatted}
                    endDate={product.endDate}
                    startDate={product.startDate}
                    siteDeliveryPatterns={product.siteDeliveryPatterns}
                  />

                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {showPinnedFilter ? (
                      <Tooltip title={product.longName}>
                        <ProductName>{product.longName}</ProductName>
                      </Tooltip>
                    ) : (
                      <ProductNameNormal>{product.longName}</ProductNameNormal>
                    )}

                    {product.conceptName && (
                      <Tooltip title={product.conceptName}>
                        <ConceptName>{product.conceptName}</ConceptName>
                      </Tooltip>
                    )}
                  </div>

                  <InfoBarCode
                    barcode={product.barcode}
                    gtincode={product.gtincode}
                  />
                </div>
                <BadgeContainer>
                  <Badge
                    {...offerTypeColor[product.offerType]}
                    type={showPinnedFilter ? 'small' : 'medium'}
                  />
                  <ShowDetails
                    producerUrl={producerUrl}
                    offerId={product.offerId}
                    offerType={product.offerType}
                    packingSelectedId={packingSelected.id}
                    selectedTypeSale={selectedTypeSale}
                  />
                </BadgeContainer>
              </ProductNameType>
            </Col>
          </Row>
          <Row className="row-details">
            <Col className="col-details" md={24} lg={14} xl={19}>
              <Row>
                <InformationProduct>
                  <TrophyOutlined className="icon-information" />
                  <div className="group-information">
                    <p className="title-information">Qualidade:</p>
                    <Quality quality={product.quality} />
                  </div>
                </InformationProduct>

                <InformationProduct>
                  <GroupOutlined className="icon-information" />
                  <div className="group-information">
                    <p className="title-information">Múltiplo:</p>
                    <span>{packingSelected?.multiple}</span>
                  </div>
                </InformationProduct>
                <InformationProduct>
                  <BgColorsOutlined className="icon-information" />
                  <div className="group-information">
                    <p className="title-information">Cores:</p>
                    <span>{product.colors}</span>
                  </div>
                </InformationProduct>

                <InformationProduct>
                  <GiftOutlined className="icon-information" />
                  <div className="group-information">
                    <p className="title-information">Embalagem:</p>
                    <SelectPacking
                      offerId={product.offerId}
                      onSelect={handleOnSelectPacking}
                      packings={product.packings}
                      value={packingSelected.id}
                    />
                  </div>
                </InformationProduct>
                <InformationProduct>
                  <ExpandOutlined className="icon-information" />
                  <div className="group-information">
                    <p className="title-information">Dimensão/Altura:</p>
                    <span>{product.dimension}</span>
                  </div>
                </InformationProduct>
              </Row>
            </Col>
            <Col className="col-details-color" md={24} lg={10} xl={5}>
              <p>
                <span className="producer-name"> {product.siteName}</span>
              </p>
              {!!product.observation && (
                <InfoObservation observation={product.observation} />
              )}
              {!!product.voucherId && (
                <InfoVoucher voucher={product.infoVoucher || ''} />
              )}
              {!!product.specialPrice && !!product.minimumQuantity && (
                <InfoDirected
                  directedMessage={
                    product.minimumQuantity === 1
                      ? `*Para aplicação do valor promocional, a compra mínima deverá ser de 1 unidade`
                      : `*Para aplicação do valor promocional, a compra mínima deverá ser de ${product.minimumQuantity} unidades`
                  }
                />
              )}
            </Col>
          </Row>
        </ProductCardComponentDetails>

        {/* Ações sobre o produto */}
        <Col xs={20} sm={16} md={14} lg={11} xl={11}>
          <Actions>
            <ProductActions
              product={product}
              packingSelected={packingSelected}
              isProducerAuthenticated={isProducerAuthenticated}
              onClickBuy={addInCart}
              onClickFastBuy={buy}
              actionsButtonType="small"
              formType="small"
              mode="row"
              theme="light"
              selectedTypeSale={selectedTypeSale}
              onChangePackingTypeSale={onChangePackingTypeSale}
            />
          </Actions>
        </Col>
      </MainContent>
    </ProductCardListComponent>
  );
}

export default memo(MinifyList);
